webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(55);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _abacus = __webpack_require__(14);
	
	var _abacus2 = _interopRequireDefault(_abacus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  store: _abacus2.default,
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function Nepohualtzintzin() {
	  var topMatrix = [];
	  var bottomMatrix = [];
	  var COLS = 10;(function init() {
	    topMatrix = Array(3).fill([]).map(function () {
	      return Array(COLS).fill(false);
	    });
	    bottomMatrix = Array(4).fill([]).map(function () {
	      return Array(COLS).fill(false);
	    });
	  })();
	
	  var toogleAt = function toogleAt(_ref) {
	    var bar = _ref.bar,
	        row = _ref.row,
	        col = _ref.col;
	
	    if (bar === 'top') {
	      toogleOnTopMatrixAt({ row: row, col: col });
	    } else if (bar === 'bottom') {
	      toogleOnBottomMatrixAt({ row: row, col: col });
	    }
	  };
	
	  var toogleOnTopMatrixAt = function toogleOnTopMatrixAt(_ref2) {
	    var row = _ref2.row,
	        col = _ref2.col;
	
	    if (!topMatrix[row][col]) {
	      toogleOnAndBelowOf({ bar: 'top', row: row, col: col });
	    } else if (topMatrix[row][col]) {
	      toogleOnAndOnAboveOf({ bar: 'top', row: row, col: col });
	    }
	  };
	
	  var toogleOnBottomMatrixAt = function toogleOnBottomMatrixAt(_ref3) {
	    var row = _ref3.row,
	        col = _ref3.col;
	
	    if (!bottomMatrix[row][col]) {
	      toogleOnAndOnAboveOf({ bar: 'bottom', row: row, col: col });
	    } else if (bottomMatrix[row][col]) {
	      toogleOnAndBelowOf({ bar: 'bottom', row: row, col: col });
	    }
	  };
	
	  function toogleOnAndOnAboveOf(_ref4) {
	    var bar = _ref4.bar,
	        row = _ref4.row,
	        col = _ref4.col;
	
	    var matrix = getMatrixForBar(bar);
	    var value = matrix[row][col];
	
	    for (var i = row; i >= 0; i--) {
	      if (matrix[i][col] === !value) break;
	
	      matrix[i][col] = !value;
	    }
	  }
	
	  function toogleOnAndBelowOf(_ref5) {
	    var bar = _ref5.bar,
	        row = _ref5.row,
	        col = _ref5.col;
	
	    var matrix = getMatrixForBar(bar);
	    var value = matrix[row][col];
	
	    for (var i = row; i < matrix.length; i++) {
	      if (matrix[i][col] === !value) break;
	
	      matrix[i][col] = !value;
	    }
	  }
	
	  function getMatrixForBar(bar) {
	    if (bar === 'top') {
	      return topMatrix;
	    }
	    if (bar === 'bottom') {
	      return bottomMatrix;
	    }
	  }
	
	  var getValue = function getValue() {
	    var value = 0;
	    value += calculateValueForMatrix(topMatrix) * 5;
	    value += calculateValueForMatrix(bottomMatrix);
	
	    return value;
	  };
	
	  function calculateValueForMatrix(matrix) {
	    var value = 0;
	    var exponet = 0;
	
	    for (var col = COLS - 1; col >= 0; col--) {
	      for (var row = 0; row < matrix.length; row++) {
	        if (matrix[row][col]) {
	          value += Math.pow(20, exponet);
	        }
	      }
	      exponet++;
	    }
	
	    return value;
	  }
	
	  var getStateAt = function getStateAt(_ref6) {
	    var bar = _ref6.bar,
	        row = _ref6.row,
	        col = _ref6.col;
	
	    var matrix = getMatrixForBar(bar);
	
	    return matrix[row][col];
	  };
	
	  var setValue = function setValue(newValue) {
	    var exponet = COLS - 1;
	
	    topMatrix = topMatrix.map(function (row) {
	      return row.map(function (cell) {
	        return false;
	      });
	    });
	    bottomMatrix = bottomMatrix.map(function (row) {
	      return row.map(function (cell) {
	        return false;
	      });
	    });
	
	    for (var col = 0; col < COLS; col++) {
	      if (newValue <= 0) break;
	
	      var valueForTopCol = Math.pow(20, exponet) * 5;
	      for (var row = topMatrix.length - 1; row >= 0; row--) {
	        if (newValue >= valueForTopCol) {
	          topMatrix[row][col] = true;
	          newValue -= valueForTopCol;
	        }
	      }
	
	      var valueForBottomCol = Math.pow(20, exponet);
	      for (var _row = 0; _row < bottomMatrix.length; _row++) {
	        if (newValue >= valueForBottomCol) {
	          bottomMatrix[_row][col] = true;
	          newValue -= valueForBottomCol;
	        }
	      }
	
	      exponet--;
	    }
	  };
	
	  return {
	    getValue: getValue,
	    setValue: setValue,
	    get value() {
	      return getValue();
	    },
	
	    toogleAt: toogleAt,
	    toogleOnTopMatrixAt: toogleOnTopMatrixAt,
	    toogleOnBottomMatrixAt: toogleOnBottomMatrixAt,
	    getStateAt: getStateAt,
	
	    getCols: function getCols() {
	      return COLS;
	    },
	    _getTopMatrix: function _getTopMatrix() {
	      return topMatrix;
	    },
	    _getBottomMatrix: function _getBottomMatrix() {
	      return bottomMatrix;
	    }
	  };
	}
	
	exports.default = Nepohualtzintzin;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(1);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _model = __webpack_require__(13);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var model = (0, _model2.default)();
	
	exports.default = new _vuex2.default.Store({
	  state: {
	    abacus: getAbacusNewState(),
	    cols: model.getCols()
	  },
	  getters: {
	    number: function number(state, getters) {
	      return model.getValue();
	    },
	    valueAt: function valueAt(state, getters, _ref) {
	      var bar = _ref.bar,
	          col = _ref.col,
	          row = _ref.row;
	
	      return model.getStateAt({ bar: bar, row: row, col: col });
	    }
	  },
	  mutations: {
	    toogleRowCol: function toogleRowCol(state, _ref2) {
	      var col = _ref2.col,
	          row = _ref2.row,
	          bar = _ref2.bar;
	
	      model.toogleAt({ bar: bar, row: row, col: col });
	      state.abacus = getAbacusNewState();
	    },
	    setAbacusNumber: function setAbacusNumber(state, _ref3) {
	      var number = _ref3.number;
	
	      model.setValue(number);
	      state.abacus = getAbacusNewState();
	    }
	  }
	});
	
	
	function getAbacusNewState() {
	  return {
	    top: model._getTopMatrix(),
	    bottom: model._getBottomMatrix(),
	    value: model.getValue()
	  };
	}

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Hello = __webpack_require__(58);
	
	var _Hello2 = _interopRequireDefault(_Hello);
	
	var _OnboardingModal = __webpack_require__(60);
	
	var _OnboardingModal2 = _interopRequireDefault(_OnboardingModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    Hello: _Hello2.default,
	    OnboardingModal: _OnboardingModal2.default
	  }
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _Item = __webpack_require__(59);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'];
	
	exports.default = {
	  name: 'abacus',
	  components: {
	    Item: _Item2.default
	  },
	  data: function data() {
	    return {
	      top: 'top',
	      bottom: 'bottom'
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    cols: function cols(state) {
	      return state.cols;
	    },
	    topRows: function topRows(state) {
	      return state.abacus.top.length;
	    },
	    bottomRows: function bottomRows(state) {
	      return state.abacus.bottom.length;
	    },
	    topMatrix: function topMatrix(state) {
	      return state.abacus.top;
	    },
	    bottomMatrix: function bottomMatrix(state) {
	      return state.abacus.bottom;
	    }
	  })),
	  methods: {
	    roman: function roman(col) {
	      return ROMAN[col - 1] || '';
	    },
	    colValue: function colValue(col) {
	      var c = col - 1;
	      var topActive = 0;
	      for (var r = 0; r < this.topMatrix.length; r++) {
	        if (this.topMatrix[r][c]) topActive++;
	      }
	      var bottomActive = 0;
	
	      for (var _r = 0; _r < this.bottomMatrix.length; _r++) {
	        if (!this.bottomMatrix[_r][c]) bottomActive++;
	      }
	      return Math.min(19, topActive * 5 + bottomActive);
	    },
	    colBars: function colBars(col) {
	      return Math.floor(this.colValue(col) / 5);
	    },
	    colDots: function colDots(col) {
	      return this.colValue(col) % 5;
	    }
	  }
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STRINGS = {
	  es: {
	    start: 'Modo reto',
	    compose: 'Componga este número',
	    current: 'Actual',
	    higher: 'Faltan',
	    lower: 'Sobran',
	    correct: '✓ Correcto',
	    next: 'Nuevo número',
	    stop: 'Cerrar'
	  },
	  en: {
	    start: 'Challenge mode',
	    compose: 'Compose this number',
	    current: 'Current',
	    higher: 'Missing',
	    lower: 'Excess',
	    correct: '✓ Correct',
	    next: 'New number',
	    stop: 'Stop'
	  }
	};
	
	exports.default = {
	  name: 'challenge-mode',
	  data: function data() {
	    return {
	      target: null,
	      lang: this.detectLang()
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    current: function current(state) {
	      return state.abacus.value;
	    }
	  }), {
	    t: function t() {
	      return STRINGS[this.lang] || STRINGS.es;
	    },
	    diff: function diff() {
	      return Math.abs(this.target - this.current);
	    },
	    isCorrect: function isCorrect() {
	      return this.target !== null && this.current === this.target;
	    },
	    diffLabel: function diffLabel() {
	      return this.current < this.target ? this.t.higher : this.t.lower;
	    },
	    diffSeverityClass: function diffSeverityClass() {
	      if (this.diff === 0) return 'diff--zero';
	      if (this.diff <= 20) return 'diff--near';
	      return 'diff--far';
	    }
	  }),
	  methods: {
	    randomNumber: function randomNumber() {
	      return Math.floor(Math.random() * 9999) + 1;
	    },
	    startChallenge: function startChallenge() {
	      this.target = this.randomNumber();
	    },
	    nextChallenge: function nextChallenge() {
	      var n = this.randomNumber();
	      while (n === this.target) {
	        n = this.randomNumber();
	      }this.target = n;
	    },
	    reset: function reset() {
	      this.target = null;
	    },
	    detectLang: function detectLang() {
	      try {
	        var stored = localStorage.getItem('nepo:lang');
	        if (stored === 'en' || stored === 'es') return stored;
	      } catch (e) {}
	      return 'es';
	    }
	  }
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _Abacus = __webpack_require__(56);
	
	var _Abacus2 = _interopRequireDefault(_Abacus);
	
	var _ChallengeMode = __webpack_require__(57);
	
	var _ChallengeMode2 = _interopRequireDefault(_ChallengeMode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'hello',
	  components: {
	    Abacus: _Abacus2.default,
	    ChallengeMode: _ChallengeMode2.default
	  },
	  computed: (0, _vuex.mapState)({
	    value: function value(state) {
	      return state.abacus.value;
	    }
	  }),
	  filters: {
	    toBaseTwenty: function toBaseTwenty(n) {
	      return n.toString(20).toUpperCase();
	    }
	  },
	  methods: (0, _extends3.default)({
	    setNumber: function setNumber(number) {
	      this.setAbacusNumber({
	        number: number
	      });
	    }
	  }, (0, _vuex.mapMutations)(['setAbacusNumber']))
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'item',
	  props: ['row', 'col', 'bar'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    active: function active(state) {
	      var active = state.abacus[this.bar][this.row - 1][this.col - 1];
	      return this.bar !== 'bottom' && active || this.bar === 'bottom' && !active;
	    }
	  }), {
	    ariaLabel: function ariaLabel() {
	      var section = this.bar === 'top' ? 'top section' : 'bottom section';
	      var state = this.active ? 'active' : 'inactive';
	      return 'Bead at column ' + this.col + ', row ' + this.row + ', ' + section + ', ' + state;
	    }
	  }),
	  methods: (0, _extends3.default)({
	    toogle: function toogle() {
	      this.toogleRowCol({
	        col: this.col - 1,
	        row: this.row - 1,
	        bar: this.bar
	      });
	    }
	  }, (0, _vuex.mapMutations)(['toogleRowCol']))
	};

/***/ },
/* 20 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var STORAGE_KEY = 'nepo:onboarded';
	var LANG_KEY = 'nepo:lang';
	
	var translations = {
	  es: {
	    title: '¿Qué es el Nepohualtzintzin?',
	    intro1: 'El Nepohualtzintzin es un ábaco mesoamericano de origen maya y azteca, utilizado mucho antes del contacto europeo para realizar cálculos aritméticos y observaciones astronómicas.',
	    intro2: 'Opera bajo un sistema vigesimal (base 20), inspirado en los veinte dedos del cuerpo humano: manos y pies.',
	    howToReadTitle: 'Cómo leerlo',
	    howToRead1: 'Cada columna representa una potencia de veinte (1, 20, 400, 8 000, …), leída de derecha a izquierda.',
	    howToRead2: 'Cada columna posee una fila superior de 3 cuentas (cada una vale 5) y una fila inferior de 4 cuentas (cada una vale 1). Una columna activada al máximo equivale a 19.',
	    howToInteractTitle: 'Cómo interactuar',
	    howToInteract: 'Haz clic sobre cualquier cuenta para activarla o desactivarla. El valor decimal y vigesimal se actualizan en vivo bajo el ábaco.',
	    cta: 'Empezar',
	    closeAria: 'Cerrar'
	  },
	  en: {
	    title: 'What is the Nepohualtzintzin?',
	    intro1: 'The Nepohualtzintzin is a Mesoamerican abacus of Maya and Aztec origin, used long before European contact for arithmetic computation and astronomical observation.',
	    intro2: 'It operates on a vigesimal (base-twenty) system, inspired by the twenty digits of the human body: hands and feet.',
	    howToReadTitle: 'How to read it',
	    howToRead1: 'Each column represents a power of twenty (1, 20, 400, 8,000, …), read from right to left.',
	    howToRead2: 'Each column has an upper row of 3 beads (each worth 5) and a lower row of 4 beads (each worth 1). A fully activated column equals 19.',
	    howToInteractTitle: 'How to interact',
	    howToInteract: 'Click any bead to toggle it on or off. The decimal and vigesimal readings update live below the abacus.',
	    cta: 'Begin',
	    closeAria: 'Close'
	  }
	};
	
	exports.default = {
	  name: 'onboarding-modal',
	  data: function data() {
	    return {
	      visible: false,
	      lang: 'es'
	    };
	  },
	
	  computed: {
	    t: function t() {
	      return translations[this.lang] || translations.es;
	    }
	  },
	  methods: {
	    setLang: function setLang(lang) {
	      this.lang = lang;
	      try {
	        window.localStorage.setItem(LANG_KEY, lang);
	      } catch (e) {}
	    },
	    dismiss: function dismiss() {
	      this.visible = false;
	      try {
	        window.localStorage.setItem(STORAGE_KEY, '1');
	      } catch (e) {}
	    },
	    onKeydown: function onKeydown(e) {
	      if (e.key === 'Escape' && this.visible) {
	        this.dismiss();
	      }
	    }
	  },
	  mounted: function mounted() {
	    var dismissed = false;
	    try {
	      dismissed = window.localStorage.getItem(STORAGE_KEY) === '1';
	    } catch (e) {
	      dismissed = false;
	    }
	    try {
	      var storedLang = window.localStorage.getItem(LANG_KEY);
	      if (storedLang === 'es' || storedLang === 'en') {
	        this.lang = storedLang;
	      }
	    } catch (e) {}
	    this.visible = !dismissed;
	    document.addEventListener('keydown', this.onKeydown);
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this.onKeydown);
	  }
	};

/***/ },
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 50 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 51 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 52 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 53 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 54 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(49)
	
	/* script */
	__vue_exports__ = __webpack_require__(15)
	
	/* template */
	var __vue_template__ = __webpack_require__(61)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(54)
	
	/* script */
	__vue_exports__ = __webpack_require__(16)
	
	/* template */
	var __vue_template__ = __webpack_require__(66)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-956704be"
	
	module.exports = __vue_exports__


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(51)
	
	/* script */
	__vue_exports__ = __webpack_require__(17)
	
	/* template */
	var __vue_template__ = __webpack_require__(63)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4ce5e4d4"
	
	module.exports = __vue_exports__


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(52)
	
	/* script */
	__vue_exports__ = __webpack_require__(18)
	
	/* template */
	var __vue_template__ = __webpack_require__(64)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7f20c7c2"
	
	module.exports = __vue_exports__


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(53)
	
	/* script */
	__vue_exports__ = __webpack_require__(19)
	
	/* template */
	var __vue_template__ = __webpack_require__(65)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-88eea85a"
	
	module.exports = __vue_exports__


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(50)
	
	/* script */
	__vue_exports__ = __webpack_require__(20)
	
	/* template */
	var __vue_template__ = __webpack_require__(62)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2bec0e42"
	
	module.exports = __vue_exports__


/***/ },
/* 61 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('hello'), _vm._v(" "), _c('onboarding-modal')], 1)
	},staticRenderFns: []}

/***/ },
/* 62 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "codice-fade"
	    }
	  }, [(_vm.visible) ? _c('div', {
	    staticClass: "onboarding-backdrop",
	    attrs: {
	      "role": "dialog",
	      "aria-modal": "true",
	      "aria-labelledby": 'onboarding-title'
	    },
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return; }
	        _vm.dismiss($event)
	      }
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "codice-rise",
	      "appear": ""
	    }
	  }, [(_vm.visible) ? _c('div', {
	    staticClass: "onboarding-modal",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('span', {
	    staticClass: "corner corner-tl",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_c('svg', {
	    attrs: {
	      "viewBox": "0 0 16 16",
	      "width": "16",
	      "height": "16"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M1 15 V8 H4 V5 H7 V2 H15",
	      "fill": "none",
	      "stroke": "currentColor",
	      "stroke-width": "1.2",
	      "stroke-linecap": "square",
	      "stroke-linejoin": "miter"
	    }
	  })])]), _vm._v(" "), _c('span', {
	    staticClass: "corner corner-tr",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_c('svg', {
	    attrs: {
	      "viewBox": "0 0 16 16",
	      "width": "16",
	      "height": "16"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M15 15 V8 H12 V5 H9 V2 H1",
	      "fill": "none",
	      "stroke": "currentColor",
	      "stroke-width": "1.2",
	      "stroke-linecap": "square",
	      "stroke-linejoin": "miter"
	    }
	  })])]), _vm._v(" "), _c('span', {
	    staticClass: "corner corner-bl",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_c('svg', {
	    attrs: {
	      "viewBox": "0 0 16 16",
	      "width": "16",
	      "height": "16"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M1 1 V8 H4 V11 H7 V14 H15",
	      "fill": "none",
	      "stroke": "currentColor",
	      "stroke-width": "1.2",
	      "stroke-linecap": "square",
	      "stroke-linejoin": "miter"
	    }
	  })])]), _vm._v(" "), _c('span', {
	    staticClass: "corner corner-br",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_c('svg', {
	    attrs: {
	      "viewBox": "0 0 16 16",
	      "width": "16",
	      "height": "16"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M15 1 V8 H12 V11 H9 V14 H1",
	      "fill": "none",
	      "stroke": "currentColor",
	      "stroke-width": "1.2",
	      "stroke-linecap": "square",
	      "stroke-linejoin": "miter"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-header"
	  }, [_c('div', {
	    staticClass: "lang-toggle",
	    attrs: {
	      "role": "group",
	      "aria-label": "Language"
	    }
	  }, [_c('button', {
	    staticClass: "lang-btn",
	    class: {
	      active: _vm.lang === 'es'
	    },
	    attrs: {
	      "type": "button",
	      "aria-label": "Español"
	    },
	    on: {
	      "click": function($event) {
	        _vm.setLang('es')
	      }
	    }
	  }, [_vm._v("ES")]), _vm._v(" "), _c('span', {
	    staticClass: "lang-sep",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("|")]), _vm._v(" "), _c('button', {
	    staticClass: "lang-btn",
	    class: {
	      active: _vm.lang === 'en'
	    },
	    attrs: {
	      "type": "button",
	      "aria-label": "English"
	    },
	    on: {
	      "click": function($event) {
	        _vm.setLang('en')
	      }
	    }
	  }, [_vm._v("EN")])]), _vm._v(" "), _c('button', {
	    staticClass: "close-btn",
	    attrs: {
	      "type": "button",
	      "aria-label": _vm.t.closeAria
	    },
	    on: {
	      "click": _vm.dismiss
	    }
	  }, [_c('svg', {
	    attrs: {
	      "viewBox": "0 0 20 20",
	      "width": "20",
	      "height": "20",
	      "aria-hidden": "true"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M4 4 L16 16 M16 4 L4 16",
	      "fill": "none",
	      "stroke": "currentColor",
	      "stroke-width": "1.4",
	      "stroke-linecap": "round"
	    }
	  })])])]), _vm._v(" "), _c('h2', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "onboarding-title"
	    }
	  }, [_vm._v(_vm._s(_vm.t.title))]), _vm._v(" "), _c('div', {
	    staticClass: "divider",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_c('svg', {
	    attrs: {
	      "viewBox": "0 0 120 12",
	      "width": "120",
	      "height": "12"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M2 6 H38 M44 6 L52 2 L60 6 L52 10 Z M66 6 H102",
	      "fill": "none",
	      "stroke": "currentColor",
	      "stroke-width": "1",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "miter"
	    }
	  }), _vm._v(" "), _c('circle', {
	    attrs: {
	      "cx": "40",
	      "cy": "6",
	      "r": "1.3",
	      "fill": "currentColor"
	    }
	  }), _vm._v(" "), _c('circle', {
	    attrs: {
	      "cx": "64",
	      "cy": "6",
	      "r": "1.3",
	      "fill": "currentColor"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M52 3.5 L57.5 6 L52 8.5 L46.5 6 Z",
	      "fill": "currentColor",
	      "opacity": "0.35"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('p', {
	    staticClass: "lede"
	  }, [_vm._v(_vm._s(_vm.t.intro1))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t.intro2))]), _vm._v(" "), _c('h3', {
	    staticClass: "rubric"
	  }, [_vm._v(_vm._s(_vm.t.howToReadTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t.howToRead1))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t.howToRead2))]), _vm._v(" "), _c('h3', {
	    staticClass: "rubric"
	  }, [_vm._v(_vm._s(_vm.t.howToInteractTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t.howToInteract))])]), _vm._v(" "), _c('div', {
	    staticClass: "cta-wrap"
	  }, [_c('button', {
	    staticClass: "start-btn",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.dismiss
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.t.cta) + "\n          ")])])]) : _vm._e()])], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 63 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "challenge-mode",
	    class: {
	      'is-correct': _vm.isCorrect, 'is-active': _vm.target !== null
	    }
	  }, [(_vm.target === null) ? _c('div', {
	    staticClass: "challenge-idle"
	  }, [_c('button', {
	    staticClass: "challenge-start",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.startChallenge
	    }
	  }, [_c('svg', {
	    staticClass: "challenge-start__glyph",
	    attrs: {
	      "viewBox": "0 0 22 14",
	      "aria-hidden": "true"
	    }
	  }, [_c('circle', {
	    attrs: {
	      "cx": "6",
	      "cy": "3",
	      "r": "1.6",
	      "fill": "currentColor"
	    }
	  }), _vm._v(" "), _c('circle', {
	    attrs: {
	      "cx": "16",
	      "cy": "3",
	      "r": "1.6",
	      "fill": "currentColor"
	    }
	  }), _vm._v(" "), _c('rect', {
	    attrs: {
	      "x": "3",
	      "y": "9",
	      "width": "16",
	      "height": "2.4",
	      "rx": "0.4",
	      "fill": "currentColor"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "challenge-start__label"
	  }, [_vm._v(_vm._s(_vm.t.start))])])]) : _c('div', {
	    staticClass: "challenge-panel"
	  }, [_c('p', {
	    staticClass: "challenge-prompt"
	  }, [_vm._v(_vm._s(_vm.t.compose))]), _vm._v(" "), _c('p', {
	    staticClass: "challenge-target",
	    class: {
	      'is-correct': _vm.isCorrect
	    }
	  }, [_vm._v(_vm._s(_vm.target))]), _vm._v(" "), (_vm.isCorrect) ? _c('div', {
	    staticClass: "challenge-feedback challenge-feedback--success"
	  }, [_c('p', {
	    staticClass: "challenge-correct"
	  }, [_vm._v(_vm._s(_vm.t.correct))]), _vm._v(" "), _c('div', {
	    staticClass: "challenge-actions"
	  }, [_c('button', {
	    staticClass: "challenge-link",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.nextChallenge
	    }
	  }, [_vm._v(_vm._s(_vm.t.next))]), _vm._v(" "), _c('span', {
	    staticClass: "challenge-link__sep"
	  }, [_vm._v("·")]), _vm._v(" "), _c('button', {
	    staticClass: "challenge-link",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.reset
	    }
	  }, [_vm._v(_vm._s(_vm.t.stop))])])]) : _c('div', {
	    staticClass: "challenge-feedback"
	  }, [_c('p', {
	    staticClass: "challenge-current"
	  }, [_c('span', {
	    staticClass: "challenge-current__label"
	  }, [_vm._v(_vm._s(_vm.t.current))]), _vm._v(" "), _c('span', {
	    staticClass: "challenge-current__value"
	  }, [_vm._v(_vm._s(_vm.current))])]), _vm._v(" "), _c('p', {
	    staticClass: "challenge-diff",
	    class: _vm.diffSeverityClass
	  }, [_c('span', {
	    staticClass: "challenge-diff__label"
	  }, [_vm._v(_vm._s(_vm.diffLabel))]), _vm._v(" "), _c('span', {
	    staticClass: "challenge-diff__value"
	  }, [_vm._v(_vm._s(_vm.diff))])]), _vm._v(" "), _c('div', {
	    staticClass: "challenge-actions"
	  }, [_c('button', {
	    staticClass: "challenge-link",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.nextChallenge
	    }
	  }, [_vm._v(_vm._s(_vm.t.next))]), _vm._v(" "), _c('span', {
	    staticClass: "challenge-link__sep"
	  }, [_vm._v("·")]), _vm._v(" "), _c('button', {
	    staticClass: "challenge-link",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.reset
	    }
	  }, [_vm._v(_vm._s(_vm.t.stop))])])])])])
	},staticRenderFns: []}

/***/ },
/* 64 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "hello"
	  }, [_c('header', {
	    staticClass: "codice-header"
	  }, [_c('h1', {
	    staticClass: "codice-title"
	  }, [_vm._v("Nepohualtzintzin")]), _vm._v(" "), _c('p', {
	    staticClass: "codice-subtitle"
	  }, [_vm._v("ábaco mesoamericano")]), _vm._v(" "), _c('svg', {
	    staticClass: "codice-glyph",
	    attrs: {
	      "viewBox": "0 0 120 14",
	      "aria-hidden": "true"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M2 11 L18 11 L18 5 L26 5 L26 11 L34 11",
	      "fill": "none",
	      "stroke": "currentColor",
	      "stroke-width": "1.2",
	      "stroke-linecap": "square"
	    }
	  }), _vm._v(" "), _c('circle', {
	    attrs: {
	      "cx": "46",
	      "cy": "7",
	      "r": "1.6",
	      "fill": "currentColor"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M54 7 L60 1 L66 7 L60 13 Z",
	      "fill": "currentColor"
	    }
	  }), _vm._v(" "), _c('circle', {
	    attrs: {
	      "cx": "74",
	      "cy": "7",
	      "r": "1.6",
	      "fill": "currentColor"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M86 11 L94 11 L94 5 L102 5 L102 11 L118 11",
	      "fill": "none",
	      "stroke": "currentColor",
	      "stroke-width": "1.2",
	      "stroke-linecap": "square"
	    }
	  })])]), _vm._v(" "), _c('abacus'), _vm._v(" "), _c('div', {
	    staticClass: "codice-readings"
	  }, [_c('div', {
	    staticClass: "reading reading--vigesimal"
	  }, [_c('span', {
	    staticClass: "reading__label"
	  }, [_vm._v("Vigesimal")]), _vm._v(" "), _c('span', {
	    staticClass: "reading__value"
	  }, [_vm._v(_vm._s(_vm._f("toBaseTwenty")(_vm.value)))]), _vm._v(" "), _c('span', {
	    staticClass: "reading__caption"
	  }, [_vm._v("base veinte")])]), _vm._v(" "), _c('div', {
	    staticClass: "codice-readings__divider",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_c('svg', {
	    attrs: {
	      "viewBox": "0 0 8 80",
	      "preserveAspectRatio": "none"
	    }
	  }, [_c('line', {
	    attrs: {
	      "x1": "4",
	      "y1": "0",
	      "x2": "4",
	      "y2": "80",
	      "stroke": "currentColor",
	      "stroke-width": "0.6",
	      "stroke-dasharray": "2 4"
	    }
	  }), _vm._v(" "), _c('circle', {
	    attrs: {
	      "cx": "4",
	      "cy": "40",
	      "r": "2",
	      "fill": "currentColor"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "reading reading--decimal"
	  }, [_c('span', {
	    staticClass: "reading__label"
	  }, [_vm._v("Decimal")]), _vm._v(" "), _c('input', {
	    staticClass: "reading__input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm.value
	    },
	    on: {
	      "input": function($event) {
	        _vm.setNumber($event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "reading__caption"
	  }, [_vm._v("base diez")])])]), _vm._v(" "), _c('challenge-mode')], 1)
	},staticRenderFns: []}

/***/ },
/* 65 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "item",
	    class: {
	      active: _vm.active
	    },
	    style: ({
	      zIndex: !_vm.active ? _vm.row : 10 - _vm.row
	    }),
	    attrs: {
	      "tabindex": "0",
	      "role": "button",
	      "aria-pressed": _vm.active ? 'true' : 'false',
	      "aria-label": _vm.ariaLabel
	    },
	    on: {
	      "click": _vm.toogle,
	      "keydown": [function($event) {
	        if (_vm._k($event.keyCode, "enter", 13)) { return; }
	        $event.preventDefault();
	        _vm.toogle($event)
	      }, function($event) {
	        if (_vm._k($event.keyCode, "space", 32)) { return; }
	        $event.preventDefault();
	        _vm.toogle($event)
	      }]
	    }
	  }, [_vm._m(0)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "kernel",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_c('span', {
	    staticClass: "kernel-ring"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "kernel-body"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "kernel-sheen"
	  })])
	}]}

/***/ },
/* 66 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "abacus-frame"
	  }, [_c('div', {
	    staticClass: "abacus",
	    attrs: {
	      "role": "grid",
	      "aria-label": "Mayan abacus, 10 columns of vigesimal positional notation"
	    }
	  }, _vm._l((_vm.cols), function(col) {
	    return _c('div', {
	      key: 'c-' + col,
	      staticClass: "column",
	      style: ({
	        animationDelay: ((col - 1) * 40) + 'ms'
	      }),
	      attrs: {
	        "role": "row"
	      }
	    }, [_c('div', {
	      staticClass: "bar bar-top",
	      attrs: {
	        "role": "gridcell"
	      }
	    }, _vm._l((_vm.topRows), function(row) {
	      return _c('span', {
	        key: 't-' + row,
	        staticClass: "bead-slot"
	      }, [_c('item', {
	        attrs: {
	          "bar": _vm.top,
	          "row": row,
	          "col": col
	        }
	      }, [_vm._v("5")])], 1)
	    })), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
	      staticClass: "bar bar-bottom",
	      attrs: {
	        "role": "gridcell"
	      }
	    }, _vm._l((_vm.bottomRows), function(row) {
	      return _c('span', {
	        key: 'b-' + row,
	        staticClass: "bead-slot"
	      }, [_c('item', {
	        attrs: {
	          "bar": _vm.bottom,
	          "row": row,
	          "col": col
	        }
	      }, [_vm._v("1")])], 1)
	    })), _vm._v(" "), _c('div', {
	      staticClass: "glyph",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }, [_c('div', {
	      staticClass: "glyph-dots"
	    }, _vm._l((_vm.colDots(col)), function(n) {
	      return _c('span', {
	        key: 'd-' + n,
	        staticClass: "glyph-dot"
	      })
	    })), _vm._v(" "), _c('div', {
	      staticClass: "glyph-bars"
	    }, _vm._l((_vm.colBars(col)), function(n) {
	      return _c('span', {
	        key: 'gb-' + n,
	        staticClass: "glyph-bar"
	      })
	    }))]), _vm._v(" "), _c('div', {
	      staticClass: "position-label",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }, [_vm._v(_vm._s(_vm.roman(col)))])])
	  }))])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "henequen",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_c('span', {
	    staticClass: "henequen-knot"
	  })])
	}]}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.3c634861639b811d231a.js